export enum OTP_ENUM {
  SING_UP = 1,
  LOGIN = 2,
  FORGOT_PASSWORD = 3,
  UPDATE_PASSWORD = 4,
}

export enum ROLES {
  USER = 1,
  ADMIN = 2,
  SUB_ADMIN = 3,
  MAINTAINER = 4,
}

export enum NOTIFICATION_TYPE {
  PUSH = 2,
  MAIL = 4
}

export const ROLES_NAME: Record<number, string> = {
  1: "USER",
  2: "ADMIN",
  3: "SUB_ADMIN",
  4: "MAINTAINER",
  5: "All",
}

export const NOTIFICATION_TYPE_NAME: Record<number, string> = {
  1: "Email",
  2: "Notification"
}

// Admin Notifications (Manage Notifications page)
export enum ADMIN_NOTIFICATION_TYPE {
  EMAIL = 1,
  BROADCAST = 2,
}

export const ADMIN_NOTIFICATION_TYPE_NAME: Record<number, string> = {
  [ADMIN_NOTIFICATION_TYPE.EMAIL]: "Email",
  [ADMIN_NOTIFICATION_TYPE.BROADCAST]: "Broadcast",
};

export enum CUSTOMER_ONBOARDING_STEP {
  PERSONAL_DETAIL = 1,
  PROPERTY_DETAIL = 2,
  DOCUMENTS = 3,
}

export enum PROPERTY_TYPE {
  HOME = 1,
  VILLA = 2,
  APARTMENT = 3,
  BUILDING = 4,
}

export enum DOCUMENT_TYPE {
  PASS_PORT = 1,
  EMIRATES_ID = 2,
  BUSINESS_LICENSE = 3,
}

export enum USER_STATUS {
  APPROVED = 1,
  PENDING = 2,
  REJECTED = 3,
}

export enum ISSUE_STATUS {
  PENDING = 1,
  ONGOING = 2,
  COMPLETED = 3,
}

export enum OFFER_STATUS {
  PENDING = 1,
  ACCEPTED = 2, // ACCEPTED BY ADMIN
  APPROVED = 3, // APPROVED BY USER,
  SCHEDULED = 4,
  INPROGRESS = 5,
  COMPLETED = 6,
  REJECTED = 7,
}

export enum CUSTOMER_QUERY {
  PENDING = 1,
  RESOLVED = 2,
}

export enum GRAPH_TYPE {
  USER_GRAPH = 1,
  SP_GRAPH = 2,
  ISSUE_GRAPH = 3,
  EARNING_GRAPH = 4
}

export enum GRAPH_TYPE_DAILY {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly'
}

export enum REQUEST_STATUS {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED"
}

export enum SENT_NOTIFICATION {
  DEFAULT = 0,
  BROADCAST = 1,
  ISSUE_STATUS_UPDATE = 2,
  NEW_USER_ONBOARD = 3
}

export enum ACCOUNT_STATUS {
  ACTIVE = 1,
  INACTIVE = 2,
  SUSPENDED = 3,
  DELETED = 4,
}

export enum VOICE_TYPE {
  CALM_FEMALE = 1,
  NEUTRAL_MALE = 2,
  CHILD_FRIENDLY = 3,
}

export const VOICE_TYPE_NAME: Record<number, string> = {
  1: "Calm Female",
  2: "Neutral Male", 
  3: "Child-Friendly",
}

// Age group options for Hydration & Goal Settings
export const AGE_GROUP: Array<{ value: string; label: string }> = [
  { value: "18-25", label: "18-25" },
  { value: "25-30", label: "25-30" },
  { value: "30-35", label: "30-35" },
  { value: "35-50", label: "35-50" },
  { value: "50-60", label: "50-60" },
  { value: "others", label: "Others" },
];

// Budget Tier enums for Tone Configuration
export enum BUDGET_TIER {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
  EXCEEDED = 4,
}

export const BUDGET_TIER_NAME: Record<number, string> = {
  1: "Low Tier (0–50%)",
  2: "Medium Tier (51–80%)",
  3: "High Tier (81–100%)",
  4: "Exceeded Tier (>100%)",
};

export const BUDGET_TIER_OPTIONS: Array<{ value: number; label: string }> = [
  { value: BUDGET_TIER.LOW, label: BUDGET_TIER_NAME[BUDGET_TIER.LOW] },
  { value: BUDGET_TIER.MEDIUM, label: BUDGET_TIER_NAME[BUDGET_TIER.MEDIUM] },
  { value: BUDGET_TIER.HIGH, label: BUDGET_TIER_NAME[BUDGET_TIER.HIGH] },
  { value: BUDGET_TIER.EXCEEDED, label: BUDGET_TIER_NAME[BUDGET_TIER.EXCEEDED] },
];

// Shared Account Role enums
export enum SHARED_ACCOUNT_ROLE {
  OWNER = 1,
  PARTNER = 2,
  CONTRIBUTOR = 3,
  VIEWER = 4,
}

export const SHARED_ACCOUNT_ROLE_NAME: Record<number, string> = {
  [SHARED_ACCOUNT_ROLE.OWNER]: "Owner",
  [SHARED_ACCOUNT_ROLE.PARTNER]: "Partner", 
  [SHARED_ACCOUNT_ROLE.CONTRIBUTOR]: "Contributor",
  [SHARED_ACCOUNT_ROLE.VIEWER]: "Viewer",
};

// Profile Status enums
export enum PROFILE_STATUS {
  ONLY_SIGNUP = 0,
  OTP_VERIFIED = 1,
  PROFILE_COMPLETED = 2,
}

export const PROFILE_STATUS_NAME: Record<number, string> = {
  [PROFILE_STATUS.ONLY_SIGNUP]: "Only Sign-up",
  [PROFILE_STATUS.OTP_VERIFIED]: "OTP Verified",
  [PROFILE_STATUS.PROFILE_COMPLETED]: "Profile Completed",
};